import React from 'react';
import PropTypes from 'prop-types';

import { Table } from 'react-bootstrap';

import UncollectedAmountRow from './row';

export default function UncollectedAmountTable({ receivables }) {
  return (
    <Table>
      <thead>
        <tr>
          <th>Invoice Number(s)</th>
          <th>Due Date</th>
          <th>Total</th>
          <th>Collected/Credited</th>
          <th>Uncollected</th>
        </tr>
      </thead>
      <tbody>
        {receivables.slice(0, 9).map(receivable => (
          <UncollectedAmountRow key={receivable.id} receivable={receivable} />
        ))}
        {receivables.length > 10 && (
          <tr>
            <td className="text-center" colSpan="5"><b>{`and ${receivables.length - 10} more`}</b></td>
          </tr>
        )}
      </tbody>
    </Table>
  );
}

UncollectedAmountTable.propTypes = {
  receivables: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
  })).isRequired,
};
